import { Component, Input, OnInit } from '@angular/core';
import { PieChartData } from 'app/components/new-navigation/charts/models/PieChartData';

declare var jQuery;

@Component({
  selector: 'domain-contribution-platform',
  templateUrl: './domain-contribution-platform.html',
  styleUrls: ['./domain-contribution-platform.scss']
})
export class DomainContributionPlatform implements OnInit {
  @Input() data;

  tooltip: any = {};
  devicePieChartData: Array<PieChartData> = [];
  colors = ['#4BC47C', '#EAF6ED', '#00BDFF', '#002F40', '#00AAE5', '#66d9ff'];

  constructor() {}

  ngOnInit() {
    setTimeout(fn => {
      jQuery('[enTooltip]').tooltip({ animation: false });
    }, 100);

    this.devicePieChartData = this?.data?.deviceDistribution?.deviceTypes.map(
      item => {
        return {
          category: item?.deviceType,
          value: item?.totalTrafficRatio,
          title: item?.deviceType
        };
      }
    );
  }
}
